<template>
  <!-- <div>
    <div starttime="0" duration="5" class="page page-0" style="display: block;"><div class="overflow-hidden svg-img-shapes" style="transform: scale(1, 1); width: 612px; height: 792px; position: relative;"><div id="main_page_div0" class="canvas-wrapper overflow-hidden d-block position-absolute" style="background-color: rgb(255, 255, 255); background-image: url(&quot;undefined&quot;); background-repeat: no-repeat; width: 612px; height: 792px; transform-origin: left top; overflow: hidden;"><div data-v-26e88da7="" id="485ba5e0-06e4-11ee-9d71-073e73ebc977" data-rotate="0" data-elementindex="0" data-translatex="612" data-translatey="336.6" data-subtype="video" data-scalex="1" data-scaley="1" data-type="video" class="position-absolute d-flex image-container target" data="[object Object]" style="transform: scale(1, 1) rotate(0deg); top: 228px; left: 0px; height: 336.6px; width: 612px; z-index: 9; visibility: visible; overflow: visible;"><video data-v-26e88da7="" starttime="0" id="video485ba5e0-06e4-11ee-9d71-073e73ebc977" src="https://productdesigner.uforialogic.com/ffmpeg-video/video-YWgYywnDpU.mp4" controlslist="timeline nodownload nofullscreen noremoteplayback noplaybackrate novolume" disablepictureinpicture="" preload="" onloadstart="this.volume=1" data-scene-id="media" style="transform: scale(1, 1);"><source data-v-26e88da7="" src="https://productdesigner.uforialogic.com/ffmpeg-video/video-YWgYywnDpU.mp4" type="video/mp4"></video></div><div id="d6e90d20-f6b2-485f-8cc0-a9dd3df58ede" data-elementindex="1" data-translatex="45" data-translatey="150" data-rotate="0" contenteditable="false" data-isselect="0" data-type="text" class="position-absolute text-object target" object-props="[object Object]" style="transform: rotate(0deg) scale(1, 1); z-index: 8; width: 262px; left: 45px; top: 150px; height: 383px; visibility: visible; align-items: center; overflow-y: initial;"><div id="editor-d6e90d20-f6b2-485f-8cc0-a9dd3df58ede" class="focus-text-div" style="font-size: 12px; line-height: 1.3; color: rgb(255, 255, 255); font-family: Ubuntu; width: 100%; height: auto !important; visibility: visible; font-weight: normal; font-style: normal; text-decoration: none; text-align: left; overflow-wrap: break-word; padding: 0px 5px;"><div><div><div style="text-align: left; font-family: Ubuntu;"><span fontsize="28" style="font-size: 28px; font-family: Ubuntu;"><span face="Ubuntu Bold" style="font-family:Ubuntu Bold;">The Fed calls it<br>
Economic Stimulus</span></span><br>
      <br>
      <span fontsize="19" style="font-size: 19px; font-family: Ubuntu;"><span face="Ubuntu Italic" style="font-family:Ubuntu Italic;">We call it helping the small<br>
business owner. </span></span><br>
      <br>
      <span face="Ubuntu" style="font-family:Ubuntu;"><span fontsize="12" style="font-size: 12px; font-family: inherit;">With the current Covid-19 health crisis bringing the economy to a virtual standstill, small business owners face challenging times. If you're struggling financially, we can help. Why not apply for a small business loan? A loan with Your Bank &amp; Trust could be just what you need to get you, and your small business, through this tough economy.<br>
<br>
Sound good? Call us today at 404-943-1632 and speak to one of our loan officers. We're Your Bank &amp; Trust, and together, we'll get through this. </span></span></div>
    </div></div></div></div><div data-v-ab023672="" id="fef6c813-bd56-4c73-bd3c-356bd40a1c6d" data-rotate="0" data-elementindex="2" data-translatex="366" data-translatey="122" data-subtype="WhiteboxLogo" data-scalex="1" data-scaley="1" data-type="image" class="position-absolute d-flex image-container target" data="[object Object]" style="transform: scale(1, 1) rotate(0deg); top: 665px; left: 123px; height: 122px; width: 366px; z-index: 7; visibility: visible; overflow: visible;"><img data-v-ab023672="" src="https://pdf-processing.bankmarketingcenter.com/svg/protectedarea/images/201508/YBTWhiteBox_Facebook.new09.svg" data-highimage="https://pdf-processing.bankmarketingcenter.com/svg/protectedarea/images/201508/YBTWhiteBox_Facebook.new09.svg" width="100%" style="transform: scale(1, 1);"><div data-v-ab023672="" class="tint-div" style="display: none;"></div></div><div data-v-ab023672="" id="7bbf298d-a546-4aa1-a390-64efcebb9067" data-rotate="0" data-elementindex="3" data-translatex="44" data-translatey="49" data-subtype="FDICLogo" data-scalex="1" data-scaley="1" data-type="image" class="position-absolute d-flex image-container target" data="[object Object]" style="transform: scale(1, 1) rotate(0deg); top: 733px; left: 32px; height: 49px; width: 44px; z-index: 6; visibility: visible; overflow: visible;"><img data-v-ab023672="" src="https://pdf-processing.bankmarketingcenter.com/svg/upload/banklogos/fdiclogo.svg" data-highimage="https://pdf-processing.bankmarketingcenter.com/svg/upload/banklogos/fdiclogo.svg" width="100%" style="transform: scale(1, 1);"><div data-v-ab023672="" class="tint-div" style="display: none;"></div></div><div data-v-ab023672="" id="759ba644-11e2-4ddc-b0df-9cf364433a2c" data-rotate="0" data-elementindex="4" data-translatex="57" data-translatey="33" data-subtype="FDICText" data-scalex="1" data-scaley="1" data-type="image" class="position-absolute d-flex image-container target" data="[object Object]" style="transform: scale(1, 1) rotate(0deg); top: 749px; left: 521px; height: 33px; width: 57px; z-index: 5; visibility: visible; overflow: visible;"><img data-v-ab023672="" src="https://pdf-processing.bankmarketingcenter.com/svg/protectedarea/images/202005/fdictext.svg" data-highimage="https://pdf-processing.bankmarketingcenter.com/svg/protectedarea/images/202005/fdictext.svg" width="100%" style="transform: scale(1, 1);"><div data-v-ab023672="" class="tint-div" style="display: none;"></div></div><div data-v-ab023672="" id="5ef52d37-2907-42a6-8f47-c687a068bd88" data-rotate="0" data-elementindex="5" data-translatex="279" data-translatey="638" data-subtype="Image" data-scalex="1" data-scaley="1" data-type="image" class="position-absolute d-flex image-container target" data="[object Object]" style="transform: scale(1, 1) rotate(0deg); top: 0px; left: 332px; height: 638px; width: 279px; z-index: 4; visibility: visible; overflow: visible;"><img data-v-ab023672="" src="https://www.bankmarketingcenter.com/protectedarea/images/202003/ec2a51aa-fbdc-42ce-8a69-530aabf0a4978_5x11_-_The_Fed_calls_it_Economic_Stimulus_-_1-resized-600.jpg#ec2a51aa-fbdc-42ce-8a69-530aabf0a497 " data-highimage="https://www.bankmarketingcenter.com/protectedarea/images/202003/8_5x11_-_The_Fed_calls_it_Economic_Stimulus_-_1.jpg" width="100%" style="transform: scale(1, 1);"><div data-v-ab023672="" class="tint-div" style="display: none;"></div></div><div data-v-6780dbfa="" id="62744ca1-b939-4dd3-beeb-cf979a4bbc9c" data-elementindex="6" data-translatex="0" data-translatey="660" data-rotate="0" data-type="shape" class="position-absolute d-flex object-add target " object-props="[object Object]" style="transform: rotate(0deg) scale(1, 1); height: 132px; width: 612px; z-index: 3; display: block !important; opacity: 1; top: 660px; left: 0px;"><div data-v-6780dbfa=""><svg data-v-6780dbfa="" xmlns="http://www.w3.org/2000/svg" style="height: 132px !important; width: 612px !important; transform: scale(1, 1); transform-origin: left top; vertical-align: middle;"><rect data-v-6780dbfa="" x="0" y="0" width="612" height="132" style="fill: rgb(255, 214, 138);"></rect></svg></div></div><div data-v-6780dbfa="" id="468d0832-44b1-4610-b5fe-7b8485be486c" data-elementindex="7" data-translatex="0" data-translatey="639" data-rotate="0" data-type="shape" class="position-absolute d-flex object-add target " object-props="[object Object]" style="transform: rotate(0deg) scale(1, 1); height: 153px; width: 612px; z-index: 2; display: block !important; opacity: 1; top: 639px; left: 0px;"><div data-v-6780dbfa=""><svg data-v-6780dbfa="" xmlns="http://www.w3.org/2000/svg" style="height: 153px !important; width: 612px !important; transform: scale(1, 1); transform-origin: left top; vertical-align: middle;"><rect data-v-6780dbfa="" x="0" y="0" width="612" height="153" style="fill: rgb(202, 159, 53);"></rect></svg></div></div><div data-v-6780dbfa="" id="371e4c45-52eb-458a-aee2-e0f49dd1aba3" data-elementindex="8" data-translatex="0" data-translatey="0" data-rotate="0" data-type="shape" class="position-absolute d-flex object-add target " object-props="[object Object]" style="transform: rotate(0deg) scale(1, 1); height: 792px; width: 612px; z-index: 1; display: block !important; opacity: 1; top: 0px; left: 0px;"><div data-v-6780dbfa=""><svg data-v-6780dbfa="" xmlns="http://www.w3.org/2000/svg" style="height: 792px !important; width: 612px !important; transform: scale(1, 1); transform-origin: left top; vertical-align: middle;"><rect data-v-6780dbfa="" x="0" y="0" width="612" height="792" style="fill: rgb(255, 161, 13);"></rect></svg></div></div></div></div></div><div class="play-pause-container show-player"><div class="bar-area d-flex justify-content-center align-items-center"><div class="video-play-pause"><div style="display: none;"><div><svg viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.75"><g filter="url(#filter0_d_725_16684)"><circle cx="36" cy="34" r="30" fill="#3F3F3F"></circle><circle cx="36" cy="34" r="29.95" stroke="#ADADAD" stroke-width="0.1"></circle></g><path d="M25.0391 43.0911V24.1788C25.0391 22.1327 27.2021 20.8173 29.0144 21.7527L47.3421 31.1942C49.3006 32.2173 49.3006 35.0234 47.3421 36.0173L29.0144 45.488C27.2021 46.4234 25.0391 45.108 25.0391 43.0911Z" fill="white"></path></g><defs><filter id="filter0_d_725_16684" x="0" y="0" width="72" height="72" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_725_16684"></feMorphology><feOffset dy="2"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_725_16684"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_725_16684" result="shape"></feBlend></filter></defs></svg></div></div><div style="display: none;"><div><svg viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.75"><g filter="url(#filter0_d_1046_19597)"><circle cx="36" cy="34" r="30" fill="#3F3F3F"></circle><circle cx="36" cy="34" r="29.95" stroke="#ADADAD" stroke-width="0.1"></circle></g></g><g opacity="0.75"><path d="M34 23H28V44H34V23Z" fill="white"></path><path d="M44 23H38V44H44V23Z" fill="white"></path></g><defs><filter id="filter0_d_1046_19597" x="0" y="0" width="72" height="72" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1046_19597"></feMorphology><feOffset dy="2"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1046_19597"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1046_19597" result="shape"></feBlend></filter></defs></svg></div></div><div style=""><div><svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"></path><path fill="#ffffff" d="M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z"></path></svg></div></div></div><div style=""><span class="icon me-5 pe-5" role="button"><svg viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7883 8.2593L0 0V21L12.7831 12.7117C13.1552 12.4751 13.462 12.147 13.6748 11.7579C13.8876 11.3689 13.9995 10.9316 14 10.487C14.0005 10.0423 13.8897 9.60482 13.6778 9.21527C13.4659 8.82571 13.1599 8.49682 12.7883 8.2593Z" fill="white"></path></svg></span></div><div style="display: none;"><span class="icon me-5 pe-5" role="button"><svg viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0H0V21H6V0Z" fill="white"></path><path d="M16 0H10V21H16V0Z" fill="white"></path></svg></span></div><input max="100" min="0" type="range" class="range__input preview"><div class="text-light text-nowrap">
    05.00 /
    05.00
  </div></div></div>
  </div> -->
  <preview-modal
    :product="product"
    :is-gray-scale-on="false"
  />
</template>

<script>
import PreviewModal from './PreviewModal/PreviewModal.vue';

export default {

  name:       'Renderer',
  components: { PreviewModal },
  data() {
    return {
      product: { // Adding dummy product json for testing
        Orientation:                'Horizontal',
        TriviaQuestions:            null,
        PageWidths:                 { double: 612 },
        PageHeights:                { double: 792 },
        Id:                         'a5fd6b65-dba6-451b-8e93-5ccbdb364e48',
        BankType:                   'Bank',
        Name:                       'Coronavirus - First Responder',
        CsvFilePath:                null,
        Size:                       '8.5x11',
        IsInch:                     true,
        IsDigitalMedia:             false,
        ConvertToBlackAndWhite:     true,
        AllowFontChanging:          true,
        AllowProductRename:         true,
        AllowSizeChange:            true,
        AllowCropping:              false,
        CropOnOff:                  false,
        AllowFieldResize:           true,
        AllowFieldMove:             true,
        AllowFieldRotate:           true,
        AllowAddingTextField:       true,
        AllowAddingBackgroundField: true,
        IsRssProduct:               false,
        AllowAddingImageField:      true,
        WidthCrop:                  612,
        HeightCrop:                 792,
        XCrop:                      0,
        YCrop:                      0,
        BaseImage:                  'https://www.bankmarketingcenter.com/temp/convertedimages/9cec13cc-e51d-439d-950f-7dc67aef22cbbase045False.png\n',
        IsGrayscale:                false,
        pages:                      [{
          objectList: [{
            AllowMove:               'true',
            AllowResize:             'true',
            AllowRotate:             'true',
            ColorSystem:             'CMYK',
            DefaultColor:            'cmyk(0% 0% 0% 0%)',
            Height:                  245,
            Id:                      'f79baebd-f72f-44f9-a92c-25a8e12aa137',
            IsHtml:                  true,
            IsVisible:               true,
            Name:                    'Header',
            PageNo:                  0,
            PdfSortOrder:            12,
            RotateDegree:            0,
            RotateX:                 0,
            RotateY:                 0,
            SortOrder:               1,
            Value:                   '<div><div style="text-align: left; font-family: &quot;Montserrat Semibold&quot;;"><span face="Montserrat Semibold" style="font-family:Montserrat Semibold;"><span fontsize="40" style="font-size: 40px; font-family: inherit;">THANKS TO YOUR COURAGE, WE’LL GET THERE.</span></span></div>\n</div>',
            modifiedHtml:            '<div><div style="text-align: left; font-family: &quot;Montserrat Semibold&quot;;"><span face="Montserrat Semibold" style="font-family:Montserrat Semibold;"><span fontsize="40" style="font-size: 40px; font-family: inherit;">THANKS TO YOUR COURAGE, WE’LL GET THERE.</span></span></div>\n</div>',
            Width:                   235,
            X:                       45,
            Y:                       69,
            elementIndex:            0,
            editor:                  null,
            locked:                  false,
            type:                    'text',
            scaleX:                  1,
            scaleY:                  1,
            isEditorEnable:          false,
            isSelected:              false,
            isEditableForRightPanel: false,
            fontFamily:              'Montserrat Semibold',
            VerticalAlign:           'Middle',
            fontSize:                40,
            lineSpacing:             '1.1',
            color:                   'rgb(89,230,219)',
            isBold:                  false,
            isItalic:                false,
            isUnderline:             false,
            isJustifyCenter:         false,
            isJustifyLeft:           true,
            isJustifyRight:          false,
            verticalAlign:           'Top',
            isJustify:               false,
            isBulletList:            false,
            isNumberList:            false,
            isSubScript:             false,
            isSupperScript:          false,
            isTextAdjustmentsNeeded: true,
            valuesForLeftPanel:      {
              fontFamily:      'Montserrat Semibold', fontSize:        40, lineSpacing:     '1.1', color:           'rgb(89,230,219)', isBold:          false, isItalic:        false, isUnderline:     false, isJustifyCenter: false, isJustifyLeft:   true, isJustifyRight:  false, verticalAlign:   'Top', isJustify:       false, isBulletList:    false, isNumberList:    false, isSubScript:     false, isSupperScript:  false,
            },
            animation: {
              speed:     50, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated: false,
          }, {
            AllowMove:               'true',
            AllowResize:             'true',
            AllowRotate:             'true',
            ColorSystem:             'CMYK',
            DefaultColor:            'cmyk(0% 0% 0% 0%)',
            Height:                  230,
            Id:                      '85c7cb81-bfa8-4c43-adfc-0161d5126e16',
            IsHtml:                  true,
            IsVisible:               true,
            Name:                    'Body',
            PageNo:                  0,
            PdfSortOrder:            11,
            RotateDegree:            0,
            RotateX:                 0,
            RotateY:                 0,
            SortOrder:               3,
            Value:                   '<div><div style="text-align: left; font-family: &quot;Montserrat Semibold&quot;;"><span face="Montserrat Semibold" style="font-family:Montserrat Semibold;"><span fontsize="18" style="font-size: 18px; font-family: inherit;">We cannot begin to adequately express our gratitude to our brave and selfless first responders. We hope and pray that you stay safe in your efforts to save others, and know that we are here to offer you any financial assistance that we can.</span></span></div>\n</div>',
            modifiedHtml:            '<div><div style="text-align: left; font-family: &quot;Montserrat Semibold&quot;;"><span face="Montserrat Semibold" style="font-family:Montserrat Semibold;"><span fontsize="18" style="font-size: 18px; font-family: inherit;">We cannot begin to adequately express our gratitude to our brave and selfless first responders. We hope and pray that you stay safe in your efforts to save others, and know that we are here to offer you any financial assistance that we can.</span></span></div>\n</div>',
            Width:                   285,
            X:                       282,
            Y:                       440,
            elementIndex:            1,
            editor:                  null,
            locked:                  false,
            type:                    'text',
            scaleX:                  1,
            scaleY:                  1,
            isEditorEnable:          false,
            isSelected:              false,
            isEditableForRightPanel: false,
            fontFamily:              'Montserrat Semibold',
            VerticalAlign:           'Middle',
            fontSize:                18,
            lineSpacing:             '1.2',
            color:                   'rgb(45,57,59)',
            isBold:                  false,
            isItalic:                false,
            isUnderline:             false,
            isJustifyCenter:         false,
            isJustifyLeft:           true,
            isJustifyRight:          false,
            verticalAlign:           'Middle',
            isJustify:               false,
            isBulletList:            false,
            isNumberList:            false,
            isSubScript:             false,
            isSupperScript:          false,
            isTextAdjustmentsNeeded: true,
            valuesForLeftPanel:      {
              fontFamily:      'Montserrat Semibold', fontSize:        18, lineSpacing:     '1.2', color:           'rgb(45,57,59)', isBold:          false, isItalic:        false, isUnderline:     false, isJustifyCenter: false, isJustifyLeft:   true, isJustifyRight:  false, verticalAlign:   'Middle', isJustify:       false, isBulletList:    false, isNumberList:    false, isSubScript:     false, isSupperScript:  false,
            },
            animation: {
              speed:     50, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated: false,
          }, {
            AllowMove:               'true',
            AllowResize:             'true',
            AllowRotate:             'true',
            ColorSystem:             'CMYK',
            DefaultColor:            'cmyk(0% 0% 0% 0%)',
            Height:                  62,
            Id:                      '0c8d6789-2415-4ba1-a5e0-264e3b169db1',
            IsHtml:                  true,
            IsVisible:               true,
            Name:                    'Banner Text',
            PageNo:                  0,
            PdfSortOrder:            10,
            RotateDegree:            0,
            RotateX:                 0,
            RotateY:                 0,
            SortOrder:               2,
            Value:                   '<div><div style="text-align: center; font-family: &quot;Montserrat Semibold&quot;;"><span face="Montserrat Semibold" style="font-family:Montserrat Semibold;"><span fontsize="12" style="font-size: 12px; font-family: inherit;">As a financial institution, we know a thing or two about risk.<br>\nBut none compares to the risk that many of you who<br>\nbank with us are taking right now. </span></span></div>\n</div>',
            modifiedHtml:            '<div><div style="text-align: center; font-family: &quot;Montserrat Semibold&quot;;"><span face="Montserrat Semibold" style="font-family:Montserrat Semibold;"><span fontsize="12" style="font-size: 12px; font-family: inherit;">As a financial institution, we know a thing or two about risk.<br>\nBut none compares to the risk that many of you who<br>\nbank with us are taking right now. </span></span></div>\n</div>',
            Width:                   512,
            X:                       50,
            Y:                       360,
            elementIndex:            2,
            editor:                  null,
            locked:                  false,
            type:                    'text',
            scaleX:                  1,
            scaleY:                  1,
            isEditorEnable:          false,
            isSelected:              false,
            isEditableForRightPanel: false,
            fontFamily:              'Montserrat Semibold',
            VerticalAlign:           'Middle',
            fontSize:                12,
            lineSpacing:             '1.1',
            color:                   'rgb(255,255,255)',
            isBold:                  false,
            isItalic:                false,
            isUnderline:             false,
            isJustifyCenter:         true,
            isJustifyLeft:           false,
            isJustifyRight:          false,
            verticalAlign:           'Middle',
            isJustify:               false,
            isBulletList:            false,
            isNumberList:            false,
            isSubScript:             false,
            isSupperScript:          false,
            isTextAdjustmentsNeeded: true,
            valuesForLeftPanel:      {
              fontFamily:      'Montserrat Semibold', fontSize:        12, lineSpacing:     '1.1', color:           'rgb(255,255,255)', isBold:          false, isItalic:        false, isUnderline:     false, isJustifyCenter: true, isJustifyLeft:   false, isJustifyRight:  false, verticalAlign:   'Middle', isJustify:       false, isBulletList:    false, isNumberList:    false, isSubScript:     false, isSupperScript:  false,
            },
            animation: {
              speed:     50, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated: false,
          }, {
            croppedSrc:                     'none',
            type:                           'image',
            AllowMove:                      'true',
            AllowResize:                    'true',
            AllowRotate:                    'true',
            AlternativeImageUrls:           ['https://www.bankmarketingcenter.com/temp/convertedimages/1f2e8a0e-206a-4c1f-b02d-3dc99f5e0ee1YBTWhiteBox_Facebook.new09False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/e5e1e8a1-b0e5-4c3b-91a4-bf46ee3f02d82c4dd0c9-e791-46e2-951c-6da3deb9f698_414False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/422f23b8-61b1-4c09-bbf6-9cab64c8e95049e6133c-7fe7-4a35-b396-f9ef683a3628_230False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/0abd88dd-9ce2-4420-b7f0-aba1c87eaf18YBTWhiteBox_3LocationsFalse.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/1f2e8a0e-206a-4c1f-b02d-3dc99f5e0ee1YBTWhiteBox_Facebook.new09False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/9b05756c-6f0b-45f6-b4b4-784e1c151792b08574ca-8f2c-4dd7-8287-75334d8b5050_120False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/c89bb803-1f0f-4f63-8b40-45eafe711f0276dc115c-165f-4f50-b453-6f667f13f3fa_345False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/6b655141-a774-499d-a0ec-a63c44a169f9z1.whiteboxFalse.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/214fd4d6-94df-4a0e-ac52-6a768415b2c9z2.whiteboxFalse.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/62e3a92f-2b37-49a1-bce7-cdfa54fa33f9a3c2374c-9b28-4d92-a7fd-ce8cd289c1d8_452False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/3b502421-b9d4-4126-97cd-0dd67f912e4903b62c89-2ac5-4d14-bd03-94e25c5f031b_497False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/6b0f74b9-148b-4033-8f0d-f8e5aed02d1b4965a967-81dc-4ca5-8a88-4780ef03cace_906False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/0efd9285-09bd-4519-a6e3-d043693dca33c1df333a-0fd4-4211-9cda-d7872297db9a_903False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/e95f8f36-32bc-483d-8301-27341701d5681b34c86a-f8f0-438e-97f7-af7561c64081_272False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/9170b5ab-8eb6-4099-ad21-efa8604e3d210e8f763c-2a77-44ff-a3d4-c011a3117fc7_552False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/0267ac94-bf2d-463e-8adb-c075ca53b31290fb045f-7294-49b4-b273-763dda6dc191_745False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/aca6180b-eee3-42fd-8d04-9491cb92d4a6b2225bf0-7a5c-4095-945f-96d80a1e59ef_588True.png;https://www.bankmarketingcenter.com/temp/convertedimages/aca6180b-eee3-42fd-8d04-9491cb92d4a6b2225bf0-7a5c-4095-945f-96d80a1e59ef_588False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/83554c8a-a5a8-4a55-87e2-bea930e56ebc7083f715-57e5-4122-ada4-944d8dfe0d52_644True.png;https://www.bankmarketingcenter.com/temp/convertedimages/83554c8a-a5a8-4a55-87e2-bea930e56ebc7083f715-57e5-4122-ada4-944d8dfe0d52_644False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/4db2ddea-62cd-4f18-87a5-53cdf940079fYB%26T%20White%20Address%20Box023True.png;https://www.bankmarketingcenter.com/temp/convertedimages/4db2ddea-62cd-4f18-87a5-53cdf940079fYB%26T%20White%20Address%20Box023False.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/4e2be6e4-e6e5-4ea0-ba5d-ece35f495bfewhite%20stacked%20YB%26T%20address%20boxTrue.png;https://www.bankmarketingcenter.com/temp/convertedimages/4e2be6e4-e6e5-4ea0-ba5d-ece35f495bfewhite%20stacked%20YB%26T%20address%20boxFalse.png'],
            AlternativeImageUrlsResVersion: [],
            DefaultImageUrl:                'https://www.bankmarketingcenter.com/temp/convertedimages/1f2e8a0e-206a-4c1f-b02d-3dc99f5e0ee1YBTWhiteBox_Facebook.new09False.png ',
            Height:                         100,
            Id:                             '17f48b93-14f0-40cd-8aab-9fbbb82c9718',
            ImageType:                      'WhiteboxLogo',
            ImageExtension:                 'png',
            IsGrayScale:                    true,
            IsVisible:                      true,
            IsHFlipped:                     false,
            IsVFlipped:                     false,
            LockAspectRatio:                'true',
            Name:                           'Address Box',
            PageNo:                         1,
            PdfSortOrder:                   9,
            RotateDegree:                   0,
            Width:                          300,
            X:                              156,
            Y:                              685,
            stencilDefaultPositionTop:      null,
            stencilDefaultPositionLeft:     null,
            stencilScale:                   1,
            scaleX:                         1,
            scaleY:                         1,
            locked:                         false,
            elementIndex:                   3,
            isSelected:                     false,
            isEditableForRightPanel:        false,
            cropScaleX:                     1,
            cropScaleY:                     1,
            cropOffsetX:                    0,
            cropOffsetY:                    0,
            isCircularCrop:                 0,
            HighResV2Height:                0,
            HighResV2Width:                 0,
            effects:                        {
              brightness:   { value: 50 }, contrast:     { value: 50 }, saturation:   { value: 50 }, blur:         { value: 0 }, tint:         { value: 0, color: '#000' }, vignette:     { value: 0 }, transparency: { value: 100 },
            },
            SvgProperty: {
              content:      '', DefaultColor: '#000000', StrokeColor:  '#000000', StrokeWidth:  0, svgScaleX:    1, svgScaleY:    1, style:        'scale(1, 1)',
            },
            HighResPath:                   null,
            isImageAddedOnCanvasFromModel: false,
            croppedHighResPath:            'none',
            DefaultImageHeight:            132,
            DefaultImageWidth:             396,
            animation:                     {
              speed:     1, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated:  false,
            SortOrder:   -1,
            IsGrayscale: false,
          }, {
            croppedSrc:                     'none',
            type:                           'image',
            AllowMove:                      'true',
            AllowResize:                    'true',
            AllowRotate:                    'true',
            AlternativeImageUrls:           ['https://www.bankmarketingcenter.com/temp/convertedimages/7fbf9b08-fc9a-42bc-b6bf-7d50c7ed6337fdiclogoFalse.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/a733b831-1649-4d68-bc76-b5dfd6e4659afdiclogowhiteFalse.png'],
            AlternativeImageUrlsResVersion: [],
            DefaultImageUrl:                'https://www.bankmarketingcenter.com/temp/convertedimages/7fbf9b08-fc9a-42bc-b6bf-7d50c7ed6337fdiclogoFalse.png ',
            Height:                         49,
            Id:                             'd500f81f-a4be-4380-8563-da8aec1fc026',
            ImageType:                      'FDICLogo',
            ImageExtension:                 'png',
            IsGrayScale:                    true,
            IsVisible:                      true,
            IsHFlipped:                     false,
            IsVFlipped:                     false,
            LockAspectRatio:                'true',
            Name:                           'Equal Housing',
            PageNo:                         1,
            PdfSortOrder:                   8,
            RotateDegree:                   0,
            Width:                          44,
            X:                              44,
            Y:                              713,
            stencilDefaultPositionTop:      null,
            stencilDefaultPositionLeft:     null,
            stencilScale:                   1,
            scaleX:                         1,
            scaleY:                         1,
            locked:                         false,
            elementIndex:                   4,
            isSelected:                     false,
            isEditableForRightPanel:        false,
            cropScaleX:                     1,
            cropScaleY:                     1,
            cropOffsetX:                    0,
            cropOffsetY:                    0,
            isCircularCrop:                 0,
            HighResV2Height:                0,
            HighResV2Width:                 0,
            effects:                        {
              brightness:   { value: 50 }, contrast:     { value: 50 }, saturation:   { value: 50 }, blur:         { value: 0 }, tint:         { value: 0, color: '#000' }, vignette:     { value: 0 }, transparency: { value: 100 },
            },
            SvgProperty: {
              content:      '', DefaultColor: '#000000', StrokeColor:  '#000000', StrokeWidth:  0, svgScaleX:    1, svgScaleY:    1, style:        'scale(1, 1)',
            },
            HighResPath:                   null,
            isImageAddedOnCanvasFromModel: false,
            croppedHighResPath:            'none',
            DefaultImageHeight:            150,
            DefaultImageWidth:             134,
            animation:                     {
              speed:     1, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated:  false,
            SortOrder:   -1,
            IsGrayscale: false,
          }, {
            croppedSrc:                     'none',
            type:                           'image',
            AllowMove:                      'true',
            AllowResize:                    'true',
            AllowRotate:                    'true',
            AlternativeImageUrls:           ['https://www.bankmarketingcenter.com/temp/convertedimages/23087ee3-d674-4fa7-b1ba-ffdf936e66f6fdictextFalse.png', 'https://www.bankmarketingcenter.com/temp/convertedimages/251638cf-fc6d-4897-9819-e648b8835fdafdictextwhiteFalse.png'],
            AlternativeImageUrlsResVersion: [],
            DefaultImageUrl:                'https://www.bankmarketingcenter.com/temp/convertedimages/23087ee3-d674-4fa7-b1ba-ffdf936e66f6fdictextFalse.png ',
            Height:                         35,
            Id:                             '302c4f0d-ffe6-4370-95e4-303803f8eb83',
            ImageType:                      'FDICText',
            ImageExtension:                 'png',
            IsGrayScale:                    true,
            IsVisible:                      true,
            IsHFlipped:                     false,
            IsVFlipped:                     false,
            LockAspectRatio:                'true',
            Name:                           'FDIC',
            PageNo:                         1,
            PdfSortOrder:                   7,
            RotateDegree:                   0,
            Width:                          60,
            X:                              510,
            Y:                              727,
            stencilDefaultPositionTop:      null,
            stencilDefaultPositionLeft:     null,
            stencilScale:                   1,
            scaleX:                         1,
            scaleY:                         1,
            locked:                         false,
            elementIndex:                   5,
            isSelected:                     false,
            isEditableForRightPanel:        false,
            cropScaleX:                     1,
            cropScaleY:                     1,
            cropOffsetX:                    0,
            cropOffsetY:                    0,
            isCircularCrop:                 0,
            HighResV2Height:                0,
            HighResV2Width:                 0,
            effects:                        {
              brightness:   { value: 50 }, contrast:     { value: 50 }, saturation:   { value: 50 }, blur:         { value: 0 }, tint:         { value: 0, color: '#000' }, vignette:     { value: 0 }, transparency: { value: 100 },
            },
            SvgProperty: {
              content:      '', DefaultColor: '#000000', StrokeColor:  '#000000', StrokeWidth:  0, svgScaleX:    1, svgScaleY:    1, style:        'scale(1, 1)',
            },
            HighResPath:                   null,
            isImageAddedOnCanvasFromModel: false,
            croppedHighResPath:            'none',
            DefaultImageHeight:            150,
            DefaultImageWidth:             253,
            animation:                     {
              speed:     1, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated:  false,
            SortOrder:   -1,
            IsGrayscale: false,
          }, {
            polygonWidth:            0,
            polygonHeight:           0,
            svgScaleX:               1,
            svgScaleY:               1,
            AllowMove:               'true',
            AllowResize:             'true',
            AllowRotate:             'true',
            Alpha:                   '100',
            ColorSystem:             'CMYK',
            DefaultColor:            'rgba(30,151,130,1)',
            Height:                  85,
            Id:                      '8f1e7a83-e3f1-40e1-b016-ecae7f8cc404',
            IsEditable:              'true',
            IsHFlipped:              false,
            IsVFlipped:              false,
            IsVisible:               'true',
            LayerPanelValue:         false,
            Name:                    'Color 1',
            PageNo:                  0,
            PdfSortOrder:            6,
            PolygonPoints:           '',
            RotateDegree:            0,
            RotateX:                 0,
            RotateY:                 0,
            SortOrder:               1,
            UseRgb:                  false,
            Width:                   562,
            X:                       25,
            Y:                       350,
            type:                    'shape',
            scaleX:                  1,
            scaleY:                  1,
            locked:                  false,
            isSelected:              false,
            initialX:                0,
            initialY:                0,
            shapeType:               'rectangle',
            isEditableForRightPanel: false,
            elementIndex:            6,
            isNewObject:             false,
            svgContent:              '',
            animation:               {
              speed:     1, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated: false,
            ColorType:  'ColorPack',
          }, {
            croppedSrc:                     'none',
            type:                           'image',
            AllowMove:                      'true',
            AllowResize:                    'true',
            AllowRotate:                    'true',
            AlternativeImageUrls:           ['https://www.bankmarketingcenter.com/protectedarea/images/202004/e54fc3f0-b312-41f2-a50c-ab191e1b42b5Img%201022-resized-600.jpg#e54fc3f0-b312-41f2-a50c-ab191e1b42b5'],
            AlternativeImageUrlsResVersion: [],
            DefaultImageUrl:                'https://www.bankmarketingcenter.com/protectedarea/images/202004/e54fc3f0-b312-41f2-a50c-ab191e1b42b5Img%201022-resized-600.jpg#e54fc3f0-b312-41f2-a50c-ab191e1b42b5 ',
            Height:                         270,
            Id:                             '49fa957c-4d60-4da8-b3be-10e1faf1e2cd',
            ImageType:                      'Image',
            ImageExtension:                 'jpg',
            IsGrayScale:                    true,
            IsVisible:                      true,
            IsHFlipped:                     false,
            IsVFlipped:                     false,
            LockAspectRatio:                'false',
            Name:                           'Photo',
            PageNo:                         1,
            PdfSortOrder:                   5,
            RotateDegree:                   0,
            Width:                          270,
            X:                              292,
            Y:                              50,
            stencilDefaultPositionTop:      null,
            stencilDefaultPositionLeft:     null,
            stencilScale:                   1,
            scaleX:                         1,
            scaleY:                         1,
            locked:                         false,
            elementIndex:                   7,
            isSelected:                     false,
            isEditableForRightPanel:        false,
            cropScaleX:                     1,
            cropScaleY:                     1,
            cropOffsetX:                    0,
            cropOffsetY:                    0,
            isCircularCrop:                 0,
            HighResV2Height:                0,
            HighResV2Width:                 0,
            effects:                        {
              brightness:   { value: 50 }, contrast:     { value: 50 }, saturation:   { value: 50 }, blur:         { value: 0 }, tint:         { value: 0, color: '#000' }, vignette:     { value: 0 }, transparency: { value: 100 },
            },
            SvgProperty: {
              content:      '', DefaultColor: '#000000', StrokeColor:  '#000000', StrokeWidth:  0, svgScaleX:    1, svgScaleY:    1, style:        'scale(1, 1)',
            },
            HighResPath:                   null,
            isImageAddedOnCanvasFromModel: false,
            croppedHighResPath:            'none',
            DefaultImageHeight:            600,
            DefaultImageWidth:             600,
            animation:                     {
              speed:     1, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated:  false,
            SortOrder:   -1,
            IsGrayscale: false,
          }, {
            croppedSrc:                     'none',
            type:                           'image',
            AllowMove:                      'true',
            AllowResize:                    'true',
            AllowRotate:                    'true',
            AlternativeImageUrls:           ['https://www.bankmarketingcenter.com/protectedarea/images/202004/cafce888-5b37-485d-b858-f45ffee228e5Img2112-resized-600.jpg#cafce888-5b37-485d-b858-f45ffee228e5'],
            AlternativeImageUrlsResVersion: [],
            DefaultImageUrl:                'https://www.bankmarketingcenter.com/protectedarea/images/202004/cafce888-5b37-485d-b858-f45ffee228e5Img2112-resized-600.jpg#cafce888-5b37-485d-b858-f45ffee228e5 ',
            Height:                         220,
            Id:                             '3aefe5ca-02b2-427d-9699-2af183ed74d3',
            ImageType:                      'Image',
            ImageExtension:                 'jpg',
            IsGrayScale:                    true,
            IsVisible:                      true,
            IsHFlipped:                     false,
            IsVFlipped:                     false,
            LockAspectRatio:                'false',
            Name:                           'Photo 1',
            PageNo:                         1,
            PdfSortOrder:                   4,
            RotateDegree:                   0,
            Width:                          220,
            X:                              37,
            Y:                              447,
            stencilDefaultPositionTop:      null,
            stencilDefaultPositionLeft:     null,
            stencilScale:                   1,
            scaleX:                         1,
            scaleY:                         1,
            locked:                         false,
            elementIndex:                   8,
            isSelected:                     false,
            isEditableForRightPanel:        false,
            cropScaleX:                     1,
            cropScaleY:                     1,
            cropOffsetX:                    0,
            cropOffsetY:                    0,
            isCircularCrop:                 0,
            HighResV2Height:                0,
            HighResV2Width:                 0,
            effects:                        {
              brightness:   { value: 50 }, contrast:     { value: 50 }, saturation:   { value: 50 }, blur:         { value: 0 }, tint:         { value: 0, color: '#000' }, vignette:     { value: 0 }, transparency: { value: 100 },
            },
            SvgProperty: {
              content:      '', DefaultColor: '#000000', StrokeColor:  '#000000', StrokeWidth:  0, svgScaleX:    1, svgScaleY:    1, style:        'scale(1, 1)',
            },
            HighResPath:                   null,
            isImageAddedOnCanvasFromModel: false,
            croppedHighResPath:            'none',
            DefaultImageHeight:            600,
            DefaultImageWidth:             600,
            animation:                     {
              speed:     1, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated:  false,
            SortOrder:   -1,
            IsGrayscale: false,
          }, {
            polygonWidth:            0,
            polygonHeight:           0,
            svgScaleX:               1,
            svgScaleY:               1,
            AllowMove:               'true',
            AllowResize:             'true',
            AllowRotate:             'true',
            Alpha:                   '100',
            ColorSystem:             'CMYK',
            DefaultColor:            'rgba(89,230,219,1)',
            Height:                  220,
            Id:                      '4042ab02-7fa0-475f-a503-5c26b6ced5e0',
            IsEditable:              'true',
            IsHFlipped:              false,
            IsVFlipped:              false,
            IsVisible:               'true',
            LayerPanelValue:         false,
            Name:                    'Color 3',
            PageNo:                  0,
            PdfSortOrder:            3,
            PolygonPoints:           '',
            RotateDegree:            0,
            RotateX:                 0,
            RotateY:                 0,
            SortOrder:               3,
            UseRgb:                  false,
            Width:                   220,
            X:                       25,
            Y:                       457,
            type:                    'shape',
            scaleX:                  1,
            scaleY:                  1,
            locked:                  false,
            isSelected:              false,
            initialX:                0,
            initialY:                0,
            shapeType:               'rectangle',
            isEditableForRightPanel: false,
            elementIndex:            9,
            isNewObject:             false,
            svgContent:              '',
            animation:               {
              speed:     1, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated: false,
            ColorType:  'ColorPack',
          }, {
            polygonWidth:            0,
            polygonHeight:           0,
            svgScaleX:               1,
            svgScaleY:               1,
            AllowMove:               'true',
            AllowResize:             'true',
            AllowRotate:             'true',
            Alpha:                   '100',
            ColorSystem:             'CMYK',
            DefaultColor:            'rgba(255,92,0,1)',
            Height:                  270,
            Id:                      'a7a8e82e-2183-4a5e-8689-4ce755a6ab08',
            IsEditable:              'true',
            IsHFlipped:              false,
            IsVFlipped:              false,
            IsVisible:               'true',
            LayerPanelValue:         false,
            Name:                    'Color 2',
            PageNo:                  0,
            PdfSortOrder:            2,
            PolygonPoints:           '',
            RotateDegree:            0,
            RotateX:                 0,
            RotateY:                 0,
            SortOrder:               2,
            UseRgb:                  false,
            Width:                   270,
            X:                       315,
            Y:                       25,
            type:                    'shape',
            scaleX:                  1,
            scaleY:                  1,
            locked:                  false,
            isSelected:              false,
            initialX:                0,
            initialY:                0,
            shapeType:               'rectangle',
            isEditableForRightPanel: false,
            elementIndex:            10,
            isNewObject:             false,
            svgContent:              '',
            animation:               {
              speed:     1, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated: false,
            ColorType:  'ColorPack',
          }, {
            polygonWidth:            0,
            polygonHeight:           0,
            svgScaleX:               1,
            svgScaleY:               1,
            AllowMove:               'true',
            AllowResize:             'true',
            AllowRotate:             'true',
            Alpha:                   '100',
            ColorSystem:             'CMYK',
            DefaultColor:            'rgba(242,255,252,1)',
            Height:                  395,
            Id:                      'b622e335-9c62-41fe-8f8e-7a6252ff2434',
            IsEditable:              'true',
            IsHFlipped:              false,
            IsVFlipped:              false,
            IsVisible:               'true',
            LayerPanelValue:         false,
            Name:                    'Color 4',
            PageNo:                  0,
            PdfSortOrder:            1,
            PolygonPoints:           '',
            RotateDegree:            0,
            RotateX:                 0,
            RotateY:                 0,
            SortOrder:               4,
            UseRgb:                  false,
            Width:                   612,
            X:                       0,
            Y:                       0,
            type:                    'shape',
            scaleX:                  1,
            scaleY:                  1,
            locked:                  false,
            isSelected:              false,
            initialX:                0,
            initialY:                0,
            shapeType:               'rectangle',
            isEditableForRightPanel: false,
            elementIndex:            11,
            isNewObject:             false,
            svgContent:              '',
            animation:               {
              speed:     1, style:     '', startTime: 0, duration:  0, onEnter:   false, onExit:    false,
            },
            isAnimated: false,
            ColorType:  'ColorPack',
          }],
          width:     612,
          height:    792,
          baseImage: 'https://www.bankmarketingcenter.com/temp/convertedimages/9cec13cc-e51d-439d-950f-7dc67aef22cbbase045False.png',
          animation: {
            speed:         1, style:         'pageAnimationNone', startTime:     0, duration:      5, onEnter:       false, onExit:        false, timeLineWidth: 140,
          },
        }],
        scaleX:             1,
        scaleY:             1,
        isShowCrop:         false,
        isAlignmentGuideOn: true,
      },
    };
  },
  mounted() {
    // get data through AJAX
    // this.html = ajax.html;
    // this.json = ajax.json;


  },
};
</script>

<style scoped>

</style>
